import router from './router/index'
import store from './store'
import {getCookies, removeCookies} from '@/utils/cookies'
router.beforeEach(async (to, from, next) => {
  let authToken = getCookies('authToken')
  let emailToken
  let cookieResponse
  let resList
  if (getCookies('_SEC_PRLG2DICC') !== null) {
    cookieResponse = getCookies('_SEC_PRLG2DICC')
    resList = cookieResponse.split('|ZW558545ZW|')
    emailToken = resList[1]
  }
  if ((to.name === 'emailVerify' && authToken === null)) {
    next()
  } else if ((to.name === 'login') && authToken === null && (emailToken !== undefined && emailToken !== null)) {
    next()
  } else {
    if (authToken === null) {
      next({
        name: 'emailVerify'
      })
    } else {
      if (store.getters.permission.permissionList === undefined) {
        store.dispatch('GetUserPermission', false).then(res => {
          console.log('to', to)
          console.log(res)
          console.log('res', res)
          next()
        }).catch((err) => {
          removeCookies('authToken')
          console.log(err)
          localStorage.loginuserData = JSON.stringify(to)
          next('/emailVerify')
        })
      } else if (to.name !== 'login' && to.path !== '/') {
        next()
      } else {
        next({
          name: 'dashboard'
        })
      }
    }
  }
})
router.afterEach(() => {
  // store.dispatch('SetLoader', {status: false, message: ''})
})



// WEBPACK FOOTER //
// ./src/permission.js